import React from 'react';
import PropTypes from 'prop-types';

const UniAccessForm = ({
  loader,
  handleProceed,
}) => {
  return (
    <button
      onClick={handleProceed}
      type="button"
      disabled={loader}
    >
      {loader ? 'Please wait...' : 'Proceed'}
    </button>
  );
};
// const dropdownOptions = PropTypes.shape({
//   accountId: PropTypes.number,
//   accountName: PropTypes.string,
// });
UniAccessForm.propTypes = {
  // dropdownOptions: PropTypes.arrayOf(dropdownOptions),
  // formScreen: PropTypes.bool,
  loader: PropTypes.bool,
  // handleFormSubmit: PropTypes.func,
  handleProceed: PropTypes.func,
};

export default UniAccessForm;
